import React from 'react';
import { Text, View } from 'react-native';
import { AgeRatingDefinition, AgeRatingDefinitions, AgeRatingKey } from 'utils/ageRating';
import { calcSizeForDevice } from 'utils/index';

type RatingProps = {
  size?: 'sm' | 'lg';
  customAppendix?: string;
  ageRatingKey: AgeRatingKey;
  append?: keyof Omit<AgeRatingDefinition, 'badge'> | 'custom';
};

const Rating: React.FC<RatingProps> = ({ ageRatingKey, append, customAppendix, size = 'sm' }) => {
  const definition = AgeRatingDefinitions[ageRatingKey];
  const appendValue = append && (append === 'custom' ? customAppendix : definition[append]);

  return (
    <View style={{ flexDirection: 'row', alignItems: 'center', gap: calcSizeForDevice(10) }}>
      <View
        style={{
          borderRadius: 4,
          alignItems: 'center',
          justifyContent: 'center',
          width: calcSizeForDevice(size === 'sm' ? 26 : 45, 48),
          height: calcSizeForDevice(size === 'sm' ? 26 : 45, 48),
          backgroundColor: definition?.badge?.color,
        }}>
        <Text
          style={{
            fontFamily: 'system-ui',
            lineHeight: 22,
            color: 'white',
            fontSize: calcSizeForDevice(size === 'sm' ? 12 : 16, 18),
            fontWeight: 'bold',
          }}>
          {definition?.badge?.label}
        </Text>
      </View>

      {appendValue && (
        <Text
          style={{
            fontFamily: 'system-ui',
            lineHeight: 22,
            color: 'white',
            fontSize: calcSizeForDevice(size === 'sm' ? 12 : 16, 20),
          }}>
          {appendValue}
        </Text>
      )}
    </View>
  );
};

export default Rating;
